/* Stylesheet */

.import_data_handler {
  .accordion {
    .header {
      --padding-start: 24px;
      --padding-end: 12px;
      --min-height: 52px;
      --background-activated: #f3f5f7;
      --ripple-color: transparent;

      .key {
        padding: 4px 0px 4px 0px;
        line-height: 1.5;
      }
    }
  }
}
